<template>
  <div class="slide">
    <div :class="[$store.state.currentAnswer.className ? $store.state.currentAnswer.className + ' trivia-answers' : 'trivia-answers']">
      <TriviaCount :current="$store.state.currentAnswer.current" :total="$store.state.currentAnswer.total" />
      <TriviaTitle :title="$store.state.currentAnswer.title" />
      <p>
        <span :class="[$store.state.currentAnswer.correct ? 'correct' : 'incorrect']">{{ $store.state.currentAnswer.checkedAnswers }}</span>
        <span class="answer-back">{{ $store.state.currentAnswer.correct ? 'Correct' : 'Incorrect' }}</span>
      </p>
      <p class="correct-answers" v-if="$store.state.currentAnswer.correct == false">
          The Correct Answer is
          <span v-for="(ans, index) in $store.state.currentAnswer.correctAnswer" :key="index">
              {{ ans }}
          </span>:
      </p>

      <p :class="['correct-answer', $store.state.currentAnswer.correctAnswers.length > 1 ? 'multiple' : '', $store.state.currentAnswer.correctAnswers.length > 3 ? 'multiple-more' : '']" v-for="obj in $store.state.currentAnswer.correctAnswers" :key="obj.key">
          {{ obj.answer }}
      </p>
      <router-link :to="'/' + $store.state.currentAnswer.nextRoute">
          <CheckButton />
      </router-link>
    </div>
  </div>
</template>

<script>
import TriviaCount from '@/components/TriviaCount.vue'
import TriviaTitle from '@/components/TriviaTitle.vue'
import CheckButton from '@/components/CheckButton.vue'

export default {
  name: 'trivia-answers',
  components: {
    TriviaCount,
    TriviaTitle,
    CheckButton
  }
}
</script>

<style lang="scss" scoped>
.trivia-answers {
  background: #fff;
  bottom: 0;
  box-sizing: border-box;
  height: 98%;
  left: 50%;
  padding: 30px 50px;
  position: fixed;
  transform: translate(-50%);
  width: 98%;

  h1 {
      line-height: 35px;
      padding-right:50px;
      margin-bottom: 0;
  }

  .correct-answers {
      margin-bottom: 10px;
  }

  .correct-answer {
      color: #666;
      font-family: "Roboto Condensed", sans-serif;
      font-size: 36px;
      font-weight: 200;
      margin: 0 0 10px;
      padding-right: 50px;

      &.multiple {
          font-size: 22px;
      }

      &.multiple-more {
          font-size: 18px;
      }
  }

  .correct {
      background: #31A508;
      border-radius: 3px 0 0 3px;
      color: #fff;
      padding: 2px 6px 1px;
  }

  .incorrect {
      background: #DE4300;
      border-radius: 3px 0 0 3px;
      color: #fff;
      padding: 2px 6px 1px;
  }

  .answer-back {
      background: #EDE9E9;
      color: #7B7B7B;
      font-weight: bold;
      padding: 2px 6px 1px;
  }

  p {
      color: #4A4A4A;
      font-family: 'Roboto Condensed', sans-serif;
      font-size: 18px;
      text-align: left;
  }
}

.trivia-4 {
    padding: 30px 50px;

    h1 {
        font-size: 24px !important;
        line-height: 1.2;
    }
}

.trivia-6 {

    h1 {
        font-size: 26px !important;
        line-height: 1.2;
    }
}

.trivia-10 {

    h1 {
        font-size: 28px !important;
        line-height: 1.3;
    }
}


</style>
